import { inBrowser } from '@varlet/shared';
import { isRef, onDeactivated, onBeforeUnmount, unref, watch } from 'vue';
import { useMounted } from './useMounted.js';
export function useEventListener(target, type, listener, options = {}) {
    if (!inBrowser()) {
        return;
    }
    const { passive = false, capture = false } = options;
    let listening = false;
    let cleaned = false;
    const add = (target) => {
        if (listening || cleaned) {
            return;
        }
        const element = unref(target);
        if (element) {
            element.addEventListener(type, listener, {
                passive,
                capture,
            });
            listening = true;
        }
    };
    const remove = (target) => {
        if (!listening || cleaned) {
            return;
        }
        const element = unref(target);
        if (element) {
            element.removeEventListener(type, listener, {
                capture,
            });
            listening = false;
        }
    };
    let watchStopHandle;
    if (isRef(target)) {
        watchStopHandle = watch(() => target.value, (newValue, oldValue) => {
            remove(oldValue);
            add(newValue);
        });
    }
    const cleanup = () => {
        watchStopHandle === null || watchStopHandle === void 0 ? void 0 : watchStopHandle();
        remove(target);
        cleaned = true;
    };
    useMounted(() => {
        add(target);
    });
    onBeforeUnmount(() => {
        remove(target);
    });
    onDeactivated(() => {
        remove(target);
    });
    return cleanup;
}
